var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { XMarkIcon } from '@heroicons/react/24/outline';
import Loading from '@web/components/layout/Loading';
import { OpenInNewTabIcon } from '@web/components/ui/icons/OpenInNewTabIcon';
import { trpc } from '@web/lib/trpc';
import { getDriveLinkByType, getIconByType } from '@web/utility';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
var DocAlertsConfigListSelect = function (_a) {
    var _b;
    var selectedDocuments = _a.selectedDocuments, setSelectedDocuments = _a.setSelectedDocuments;
    var t = useTranslation().t;
    var documents = trpc.documents.useQuery({
        ids: selectedDocuments
    });
    if (documents.isLoading)
        return _jsx(Loading, {});
    return (_jsx("div", { children: _jsx("ul", __assign({ className: "divide-y divide-gray-100" }, { children: (_b = documents.data) === null || _b === void 0 ? void 0 : _b.map(function (document) { return (_jsxs("li", __assign({ className: "flex items-center justify-between gap-x-3 py-3" }, { children: [_jsx("div", __assign({ className: "min-w-0 flex-1 text-gray-500" }, { children: _jsxs("div", __assign({ className: "flex min-w-0 items-center gap-1" }, { children: [_jsx("span", __assign({ className: "shrink-0" }, { children: getIconByType(document.type, { width: '16', height: '16' }) })), _jsx("span", __assign({ className: "truncate" }, { children: document.title })), _jsx(Link, __assign({ to: getDriveLinkByType(document.type, document.slugId), target: "_blank", rel: "noopener noreferrer", className: "shrink-0 text-indigo-600 hover:text-indigo-800", "aria-label": t('docAlerts.modal.openDocument') }, { children: _jsx(OpenInNewTabIcon, { width: "16", height: "16" }) }))] })) })), _jsx("div", __assign({ className: "shrink-0 text-gray-500" }, { children: _jsx("button", __assign({ type: "button", onClick: function () {
                                setSelectedDocuments(selectedDocuments.filter(function (id) { return id !== document.id; }));
                            }, className: "teg-gray-500 border-none" }, { children: _jsx(XMarkIcon, { className: "w-5 h-5" }) })) }))] }), document.id)); }) })) }));
};
export default DocAlertsConfigListSelect;
